module.exports = __webpack_public_path__ + "img/edit.b84c56c2.svg";